import { NgModule } from '@angular/core';

import { PublishersComponent } from './publishers.component';
import { SharedModule } from "../shared/shared.module";
import { CommonModule } from "@angular/common";
import { PublishersService } from "./publishers.service";
import { PublisherInfoComponent } from './publisher-info-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PublisherSettingsComponent } from './publisher-settings-modal.component';
import { PublisherSettingsFormComponent } from './publisher-settings-modal-form.component';
import { PublisherMappingsComponent } from './publisher-mappings-modal.component';
import { PublisherMappingsFormComponent } from './publisher-mappings-form-modal.component';
import {ColorPickerModule} from 'angular2-color-picker';

@NgModule({
    imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule, ColorPickerModule],
    exports: [],
    entryComponents: [PublisherSettingsFormComponent, PublisherMappingsFormComponent],
    declarations: [PublishersComponent, PublisherInfoComponent, PublisherSettingsComponent, PublisherSettingsFormComponent, PublisherMappingsComponent, PublisherMappingsFormComponent],
    providers: [PublishersService],
})
export class PublishersModule { }



// WEBPACK FOOTER //
// ./src/app/publishers/publishers.module.ts